<style scoped>
  @import "../../../assets/css/table-list.css";
  .detail-group section{ margin-bottom: 20px; }
  .detail-group section label{ margin-right: 15px; }
  .detail-group section label,.detail-group section span{ display: inline-block; }
</style>
<style>
  .ivu-table-cell{ padding-top: 5px;padding-bottom:5px; }
</style>
<template>
  <div>
    <h3 class="title">商铺信息列表</h3>
    <div class="margin-bottom-10 header-group">
      <Select v-model="params.CondList[0].Key" @on-change="change_condList">
        <Option v-for="(item,index) in d_search_key" :value="item.value" :key="index">{{ item.label }}</Option>
      </Select>
      <Input v-model="params.CondList[0].Value" placeholder="请输入搜索内容" />
      <Button type="primary" @click="search()">查询</Button>
      <Button type="primary" @click="to_add()" class="right">新增</Button>
      <Button type="primary" @click="to_export" class="btn-right" :loading="loading_export">导出</Button>
      <Button type="primary" @click="to_export('all')" class="btn-right" :loading="loading_export_all">导出全部</Button>
      <Button type="error" @click="to_delMore" class="btn-right">批量删除</Button>
    </div>
    <div>
      <Table ref="selection" border :columns="d_columns" :data="d_data" @on-selection-change="get_select_data"></Table>
      <div class="margin-top-20">
        <Page :total="d_total" show-sizer show-total @on-change="flip" @on-page-size-change="change_size" class="pull-right"></Page>
        <div class="clear-both"></div>
      </div>
    </div>
    <Modal
      v-model="d_modal_add"
      :title="d_modal_title"
      width="600px"
      footer-hide>
      <Form ref="formValidate" :model="add_params" :rules="ruleValidate" :label-width="80">
            <FormItem label="商铺地址" prop="Name">
              <Input v-model="add_params.Name" placeholder="请输入商铺地址" style="width: 200px;"></Input>
            </FormItem>
            <FormItem label="产权证号" prop="PropNum">
              <Button type="primary" shape="circle" icon="ios-add" @click="to_openProp"></Button>
              <span v-if="add_params.PropNum!=''" class="margin-left10">已选产权证号：{{ add_params.PropNum }}</span>
            </FormItem>
            <Modal
              v-model="d_modal_prop"
              title="选择产权证号"
              footer-hide>
              <div class="margin-bottom-10 header-group">
                <Select v-model="prop_params.CondList[0].Key" @on-change="change_condList_prop">
                  <Option v-for="(item,index) in d_search_key_prop" :value="item.value" :key="index">{{ item.label }}</Option>
                </Select>
                <Input v-model="prop_params.CondList[0].Value" placeholder="请输入搜索内容" />
                <Button type="primary" @click="search_prop()">查询</Button>
              </div>
              <Table highlight-row border ref="currentRowTable" height="300" :columns="d_columns_prop" :data="d_data_prop" @on-current-change="change_prop"></Table>
            </Modal>
            <FormItem label="商铺面积" prop="Area">
              <Input v-model="add_params.Area" class="all-input-margin"></Input>平米
            </FormItem>
            <FormItem label="商铺照片" prop="photos">
            <Upload
              ref="shopImgList"
              :default-file-list="d_defaultList"
              :action="$store.state.app.baseUrl + '/api/Pub/UploadFile?outType=shop&&type=商铺图片'"
              multiple
              :headers="{Authorization:token}"
              :on-preview="img_preview">
              <Button icon="ios-cloud-upload-outline">请选择文件</Button>
            </Upload>
            <Modal title="图片预览" v-model="d_img_visible" @on-cancel="cancel_preview" footer-hide>
              <img :src="d_img_name" v-if="d_img_visible" style="width: 100%">
            </Modal>
          </FormItem>
        <FormItem label="备注" prop="Notes">
          <Input v-model="add_params.Notes" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="edit_confirm('formValidate')">保存</Button>
          <Button @click="add_modal_cancel" class="margin-left10">取消</Button>
        </FormItem>
      </Form>
    </Modal>
    <Modal
      v-model="d_modal_detail"
      title="查看详情"
      footer-hide>
        <div class="detail-group">
          <section><label>商铺编号：</label><span>{{ d_data_detail.ID || '无' }}</span></section>
          <section><label>商铺地址：</label><span>{{ d_data_detail.Name || '无' }}</span></section>
          <section><label>所属产权：</label><span>{{ d_data_detail.PropNum || '无' }}</span></section>
          <section><label>面积：</label><span>{{ d_data_detail.Area || 0 }} ㎡</span></section>
          <section>
            <label class="pull-left">状态：</label>
            <div class="pull-left"><p v-for="(item,index) in d_data_detail.State">{{item}}</p></div>
            <div class="clear-both"></div>
          </section>
          <section><label>备注：</label><span>{{ d_data_detail.Notes || '无' }}</span></section>
        </div>
    </Modal>
  </div>
</template>
<script>
  import apiShop from '@/api/shop.js';
  import apiProp from '@/api/prop.js';
  import mixin from '@/components/common/mixin.js';
  export default {
    name:'shopInfo',
    mixins: [mixin],
    data() {
      return {
        token:'',
        params: {},
        add_params:{},
        ruleValidate: {
          Name: [
            { required: true, message: '商铺地址为必填项', trigger: 'blur' }
          ],
          PropNum: [
            { required: true, message: '产权证号为必选项'}
          ],
          Area: [
            { required: true, message: '商铺面积为必填项', trigger: 'blur' },
            { type: 'string',pattern:/^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/, message:'面积必须大于0小于131072的数字', trigger:'blur'},
          ]
        },
        d_total: 0,
        d_page: 1,
        d_page_size: 10,
        d_search_key:[
          {
            value: 's.ID',
            label: '编号'
          },
          {
            value: 's.PropNum',
            label: '产权证号'
          },
          {
            value: 's.Name',
            label: '商铺地址'
          },
          {
            value: 's.Notes',
            label: '备注'
          }
        ],
        d_modal_add: false,
        d_modal_title: '',
        d_columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '商铺编号',
            key: 'ID',
            width:140
          },
          {
            title: '商铺地址',
            key: 'Name',
            width:200
          },
          {
            title: '租户',
            key: 'BPartyName',
            width:200
          },
          {
            title: '经营范围',
            key: 'BusinessScope',
            width:100
          },
          {
            title: '所属产权',
            key: 'PropNum',
            width:100
          },
          {
            title: '租赁合同面积/㎡',
            key: 'Area',
            width:140
          },
          {
            title: '状态',
            key: 'State',
            width:220
          },
          {
            title: '备注',
            key: 'Notes',
            width:220,
            ellipsis: true
          },
          {
            title: "操作",
            key: "do",
            width: 200,
            fixed:'right',
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.to_edit(params.row);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: "<p>您确认要删除该条数据吗？</p>",
                          onOk: () => {
                            this.to_delete(params.row.ID);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                ),
                h(
                  "Button",
                  {
                    props: {
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.to_detail(params.row);
                      }
                    }
                  },
                  "查看"
                )
              ])
            }
          }
        ],
        d_data: [],
        d_modal_type: '',
        d_defaultList:[],
        d_del_data:'', // 批量删除
        d_img_visible: false,
        d_img_name:'',
        d_modal_prop: false,
        d_columns_prop: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: '产权证号',
            key: 'PropNum'
          },
          {
            title: '项目名称',
            key: 'ProjName'
          }
        ],
        d_data_prop: [],
        d_search_key_prop:[
          {
            value: 'p.PropNum',
            label: '产权证号'
          },
          {
            value: 'p.ProjName',
            label: '项目名称'
          },
          {
            value: 'p.Province',
            label: '省'
          },
          {
            value: 'p.City',
            label: '市'
          },
          {
            value: 'p.County',
            label: '区'
          },
          {
            value: 'p.Address',
            label: '详细地址'
          }
        ],
        prop_params:{},
        d_data_detail:{},
        d_modal_detail:false,
        loading_export:false,
        loading_export_all:false,
      };
    },
    methods: {
      to_openProp (){ this.d_modal_prop = true; },
      change_condList_prop(value){
        if((value=='p.PropNum') || (value=='p.ProjName') || (value=='p.Address')){
          this.prop_params.CondList[0].Operator = 'like';
        }else {
          this.prop_params.CondList[0].Operator = '=';
        }
      },
      search_prop(){
        this.pull_data_prop();
      },
      pull_data_prop(){
        let _this = this;
        apiProp.getList.post(this.prop_params).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let requestResult = _data.data.Data;
            _this.d_data_prop = requestResult.RowsList;
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      change_prop (currentRow){
        this.d_modal_prop = false;
        this.add_params.PropNum = currentRow.PropNum;
      },
      change_condList(value){
        if((value=='s.PropNum') || (value=='s.Name') || (value=='p.Address') || (value=='c.ID')){
          this.params.CondList[0].Operator = 'like';
        }else {
          this.params.CondList[0].Operator = '=';
        }
      },
      search() {
        this.params.PageIndex = 1;
        this.pull_data();
      },
      flip(page) { //翻页条件，每页多少条，多少页
        this.params.PageIndex = page;
        this.params.PageSize = this.d_page_size;
        this.pull_data();
      },
      change_size(size) { //改变limit 每页显示多少条
        this.params.PageSize = size;
        this.pull_data();
      },
      pull_data() {
        let _this = this;
        apiShop.getList.post(this.params).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录成功+执行成功
            let requestResult = _data.data.Data;
            _this.d_total = requestResult.Total;
            _this.d_data = requestResult.RowsList;
            _this.pull_data_prop();
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      to_add(){
        this.d_modal_add = true;
        this.d_modal_type = 'add';
        this.d_modal_title = '添加商铺';
        this.add_params = JSON.parse(JSON.stringify(apiShop.add.data));
      },
      to_edit(row){
        this.d_modal_type = 'edit';
        this.d_modal_title = '修改商铺';
        apiShop.getEditDto(row.ID).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.add_params = _data.data.Data;
            this.add_params.Area = this.add_params.Area+'';
            let fileList = this.add_params.FileList;
            let defaultList = [];
            for(let i=0;i<fileList.length;i++){
              let thisFile = {};
              thisFile.name = fileList[i].SaveName;
              thisFile.url = fileList[i].SaveName;
              defaultList.push(thisFile);
            }
            this.d_defaultList = defaultList;
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
//        图片赋值
//        this.$refs['formValidate'].validate((valid)=> {});//重新验证，不然会有提示
        this.d_modal_add = true;
      },
      add_modal_cancel(){
        this.d_modal_add = false;
      },
      edit_confirm (name) {
        let _this = this;
        this.add_params.FileList = [];
        let shopImgList = this.$refs.shopImgList.fileList;
        let fileList = [];
        if(shopImgList.length>0){
          for(let i=0;i<shopImgList.length;i++){
            let currFile = {};
            currFile.OutType = 'shop';
            currFile.Type = '商铺图片';
            if(shopImgList[i].response){
              currFile.SaveName = shopImgList[i].response.Data;
            }else {
              currFile.SaveName = shopImgList[i].name;
            }
            fileList.push(currFile);
          }
        }
        this.add_params.FileList = fileList;
        this.$refs[name].validate((valid) => {
          if (valid) {
            if( Number(this.add_params.Area)>131072 ){
              this.$Message.error('商铺面积不能大于 "131072" !');
             return;
            }
            this.submit_edit_data();
          } else {
            this.$Message.error('验证失败!');
          }
        })
      },
      submit_edit_data(){
        let _this = this;
        this.add_params.Area = Number.parseFloat(Number(this.add_params.Area).toFixed(2));
        if(_this.d_modal_type=='add'){
          apiShop.add.post(this.add_params).then((_data) => {
            if(_data.data.ExeSuccess && _data.data.LoginSuccess){
              this.d_modal_add = false;
              this.$refs.shopImgList.clearFiles(); //不知道这句话在这里是否有用
              this.pull_data();
            }else {
              this.$Message.error(_data.data.Msg);
            }
          });
        }else if(_this.d_modal_type=='edit'){
          apiShop.edit.post(this.add_params).then((_data) => {
            if(_data.data.ExeSuccess && _data.data.LoginSuccess){
              this.d_modal_add = false;
              this.$refs.shopImgList.clearFiles();
              this.pull_data();
            }else {
              this.$Message.error(_data.data.Msg);
            }
          });
        }
      },
      to_delMore(){
        if(this.d_del_data.length>0){
          this.$Modal.confirm({
            title: "提示",
            content: "<p>您确认要删除这组数据吗？</p>",
            onOk: () => {
              this.to_delete(this.d_del_data);
            },
            onCancel: () => {}
          });
        }else {
          this.$Message.warning('请选择要删除的列');
        }
      },
      get_select_data(row){
        let delData = '';
        for(let i=0;i<row.length;i++){
          delData+=row[i].ID+',';
        }
        delData=(delData.substring(delData.length-1)==',')?delData.substring(0,delData.length-1):delData; // 去掉末尾逗号
        this.d_del_data = delData;
      },
      to_delete(_idList){
        apiShop.del(_idList).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.$Message.success('删除成功');
            this.pull_data();
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      to_detail(row){
         this.d_data_detail = JSON.parse(JSON.stringify(row));
         if(this.d_data_detail.State){
           this.d_data_detail.State = this.d_data_detail.State.split(',');
         }
        this.d_modal_detail = true;
      },

      to_export(_type){ //导出
        // let condList = this.params.CondList[0];
        // if(condList.Value ===''){
        //   delete this.params.CondList;
        // }
        let _this = this;
        if(_type==='all'){
          this.params.PageIndex = 1;
          this.params.PageSize = 10000000;
          this.loading_export_all = true
        }else {
          this.loading_export = true
        }
        apiShop.export.post(this.params).then((_data) => {
          setTimeout(function () {
            _this.loading_export = false;
            _this.loading_export_all = false;
          },1000)
          let blob = _data.data;
          let reader = new FileReader();
          reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
          reader.onload = function (e) {
            // 转换完成，创建一个a标签用于下载
            let a = document.createElement('a');
            a.download = '商铺列表.xlsx';
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        });
      }
    },
    created() {
      this.params = JSON.parse(JSON.stringify(apiShop.getList.data));
      this.add_params = JSON.parse(JSON.stringify(apiShop.add.data));
      this.prop_params = JSON.parse(JSON.stringify(apiProp.getList.data));
      this.pull_data();
    },
    mounted(){
      this.params.CondList[0].Key = 'c.ID'; //默认查询状态，产权证号
      this.params.CondList[0].Operator = 'like';
      this.token = sessionStorage.getItem('token');
      this.prop_params.PageIndex = 1;
      this.prop_params.PageSize = 100;
    }
  }
</script>






